module.exports = __webpack_public_path__ + "img/com.codeway.poseapp.8746e8a0.png";